// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  id: string,
  label: string,
  inputChanged: (value: number) => void,
  headTitle: string,
  initialValue: number,
  big?: boolean,
};

type State = {
  isOpen: boolean,
  counter: number,
};

class DropdownGuest extends PureComponent<Props, State> {
  props: Props;

  state: State = {
    isOpen: false,
    counter: this.props.initialValue,
  };

  wrapperRef: any;

  static defaultProps = {
    id: 'ID',
    initialValue: 0,
    label: 'Label',
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  _changeNbPeople = (operator: string, newValue: number): void => {
    const { counter } = this.state;
    let newStateValue = counter;
    switch (operator) {
      case '+':
        newStateValue += 1;
        break;
      case '-':
        newStateValue -= 1;
        break;
      default:
        newStateValue = newValue;
        break;
    }

    if (newStateValue >= 0 && newStateValue <= 100) {
      this.setState({ counter: newStateValue }, () => {
        this.props.inputChanged(this.state.counter);
      });
    }
  }

  _renderCounterInput = () => {
    const { counter } = this.state;

    return (
      <div className="input-custom input-custom--guest ">
        <span
          role='button'
          tabIndex={0}
          onClick={() => this._changeNbPeople('-', 0)}>
          -
        </span>
        <input
          type="number"
          name="increment"
          value={counter}
          min="0"
          max="100"
          onChange={(event) => this._changeNbPeople('', event.target.value)} />
        <span
          role='button'
          tabIndex={0}
          onClick={() => this._changeNbPeople('+', 0)}>
          +
        </span>
      </div>
    );
  }

  render() {
    const { isOpen, counter } = this.state;
    const { label, headTitle, big } = this.props;

    const classNames = dynamicClassName('dropdown dropdown--guest dropdown--select');
    big && classNames.add('dropdown--big');
    isOpen && classNames.add('is-open');

    return (
      <div className={classNames.build()} ref={this.setWrapperRef}>
        <span
          className="dropdown__head ft-h6 ft-up"
          onClick={this.handleClickDropDown}
          role='button'
          tabIndex={0}>
          {big && <span className="dropdown__subhead">{label}</span>}
          <span className="dropdown__label">{counter !== 0 ? `${counter} invités` : headTitle}</span>
        </span>
        <div className="dropdown__list">
          <span
            className="dropdown__head ft-h6 ft-up"
            onClick={this.handleClickDropDown}
            role='button'
            tabIndex={0}>
            {big && <span className="dropdown__subhead">{label}</span>}
            <span className="dropdown__label">{headTitle}</span>
          </span>
          <div className="dropdown__wrapper">{this._renderCounterInput()}</div>
        </div>
      </div>
    );
  }

  handleClickDropDown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };
}

export default DropdownGuest;
